module.exports = __webpack_public_path__ + "img/album01_18.a53c75c1.jpg";